/**
 * Whether the "Switch to FDA Submission View" / "Back to classic view" control
 * is offered on the drug page.
 *
 * FALSE as of 2026-08-17-c. Submission view is the only view now, so an escape
 * hatch back to classic no longer makes sense to a user.
 *
 * The classic path itself is NOT removed — it is still reachable in code
 * (`sbaCycleInfo == null`), still fetched by the legacy branch of
 * `GET /drugs/{id}/sbas`, and still fully tested. Re-exposing the control is
 * flipping this one constant.
 *
 * It lives in its own module for one reason: so the page-level suites can
 * `vi.mock` it back to `true` and keep exercising the retained toggle
 * behaviour (request mode, status copy, route gating, newest-request-wins).
 * Hard-coding `false` at the call site instead would have left ~19 of those
 * tests asserting against a control that can never render — the code would be
 * "kept" but silently unverified, which is the failure mode this avoids.
 */
export const SUBMISSION_VIEW_TOGGLE_VISIBLE = false;
